import { render, staticRenderFns } from "./accountTX.vue?vue&type=template&id=7fda24b0"
import script from "./accountTX.vue?vue&type=script&lang=js"
export * from "./accountTX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports